import { Table } from "../../../utils/models/data";
import {
  FlashPCBTable,
  TableCell,
  TableHeaderCell,
  TableHeaderRow,
  TableRow,
} from "../../../constants/Styles";

export default function DataTable({ table }: { table: Table }) {
  return (
    <FlashPCBTable>
      <thead>
        <TableHeaderRow>
          {table.headers.map((header, index) => (
            <TableHeaderCell key={`${header}-${index}`}>
              {header}
            </TableHeaderCell>
          ))}
        </TableHeaderRow>
      </thead>
      <tbody>
        {table.data.map((row, index) => {
          return (
            <TableRow key={`${index}-${row.join(",")}`}>
              {row.map((column, index) => (
                <TableCell key={`${index}-${column}`}>{column}</TableCell>
              ))}
            </TableRow>
          );
        })}
      </tbody>
    </FlashPCBTable>
  );
}
